import { useCallback, useEffect, useState } from 'react';

import { getStores } from '@/modules/inventory/stores/redux/StoreCRUD';

export interface RequestMaterialWarehouseOption {
  id: string;
  name: string;
  is_default?: boolean;
}

interface UseRequestMaterialWarehousesParams {
  companyId: string;
  skip?: boolean;
  onError?: (message: string) => void;
}

export default function useRequestMaterialWarehouses({
  companyId,
  skip = false,
  onError,
}: UseRequestMaterialWarehousesParams) {
  const [warehouseOptions, setWarehouseOptions] = useState<RequestMaterialWarehouseOption[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchWarehouses = useCallback(async (company: string) => {
    if (!company || company === 'global') {
      setWarehouseOptions([]);
      return;
    }

    setLoading(true);
    try {
      const response = await getStores({ company_id: company, page_size: 200 });
      setWarehouseOptions(
        (response.results || []).map((store) => ({ id: store.id, name: store.name, is_default: store.is_default ?? false }))
      );
    } catch (_error) {
      onError?.('Không thể tải danh sách kho.');
      setWarehouseOptions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (skip || !companyId) return;
    void fetchWarehouses(companyId);
  }, [companyId, skip]);

  return { warehouseOptions, loading };
}
